import {get} from './calls';
import config from '../config/config';

export default {
  getProfile: () => get(`${config.BFF_BASE_URL}/api/profile`)
};
